<template>
    <div name="input-phone" class="input-phone">
        <loading v-if="isLoading" />
        <div class="header" @click="goBack">← 이전 화면</div>
        <div class="wrapper">
            <div class="input-area">
                <div class="title">휴대전화 번호를 입력해주세요</div>
                <span class="title-description">건강측정 결과를 카카오톡 알림톡으로 보내드려요.<br>체성분 분석기(인바디) 측정 시 기기에 같은 번호를 입력해주세요.</span>
                <div class="phone-input" v-if="step === 0">
                    <div class="pad-header">
                        <span class="warning">번호를 정확하게 입력하신 후 [확인] 버튼을 눌러주세요</span>
                        <div class="input">{{ convertPhone(number) }}</div>
                    </div>

                    <div class="number-pad">
                        <div class="number-page-row">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);"  @click="inputNumber('1')">
                                <span class="number">1</span>
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);"  @click="inputNumber('2')">
                                <span class="number">2</span>
                            </div>
                            <div class="key" @click="inputNumber('3')">
                                <span class="number">3</span>
                            </div>
                        </div>  
                        <div class="number-page-row" style="border-top: 2px solid var(--xi-gray-2, #C1C5C9);">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('4')">
                                <span class="number">4</span>
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('5')">
                                <span class="number">5</span>
                            </div>
                            <div class="key" @click="inputNumber('6')">
                                <span class="number">6</span>
                            </div>
                        </div>  
                        <div class="number-page-row" style="border-top: 2px solid var(--xi-gray-2, #C1C5C9);">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('7')">
                                <span class="number">7</span>
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('8')">
                                <span class="number">8</span>
                            </div>
                            <div class="key" @click="inputNumber('9')">
                                <span class="number">9</span>
                            </div>
                        </div>  
                        <div class="number-page-row" style="border-top: 2px solid var(--xi-gray-2, #C1C5C9);">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="backspace">
                                <img style="width: 3.2vw;" src="../../assets/showcase/xi/backspace.png" />
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('0')">
                                <span class="number">0</span>
                            </div>
                            <div :class="number.length === 11 ? 'enter-active':'enter'" @click="enter">
                               <span>확인</span>
                            </div>
                        </div>  
                    </div>
                </div>
                <div class="input-check" v-else>
                    <div class="phone-number-box">
                        <span class="phone-number-info-text">입력하신 휴대전화 번호가 정확한지<br>다시 한 번 확인해주세요.</span>
                        <span class="phone-number-text">{{ convertPhone(number) }}</span>
                    </div>

                    <div class="button-list">
                        <div class="button-yes" @click="yes">네,맞아요</div>
                        <div class="button-no" @click="step = 0">아니요,<br>다시 입력할게요</div>
                    </div>
                </div>

            </div>
            
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import Loading from '@/components/molecules/Loading';

export default {
    components: { Loading },
    name: 'inputPhone',
    data: function()
    {
        return {
            isLoading: false,
            step: 0,
            number: '010'
        }
    },
    computed: {
        authType: function() {
            const showcase = this.$route.params.showcase
            if (showcase === 'kocom') {
                return 'KOCOM'
            }
            else if (showcase === 'soldoc') {
                return 'SOLDOC'
            }
            else if (showcase === 'xi') {
                return 'XIHOME'
            }
            else if (showcase === 'seoulone') {
                return 'SEOULONE'
            }
            else if (showcase === 'lynn') {
                return 'LYNN'
            }
            else if (showcase === 'bodyfriend') {
                return 'BODYFRIEND'
            }
            else 
            {
                return showcase;
            }
            
        }
    },
    methods: {
        convertPhone: function(number)
        {
            if(number.length <= 3)
            {
                return `${number.substring(0, 3)}-`
            }
            else if(number.length > 3 && number.length <= 7)
            {
                return `${number.substring(0, 3)}-${number.substring(3, 7)}`
            }
            else if(number.length > 7 && number.length <= 11)
            {
                return `${number.substring(0, 3)}-${number.substring(3, 7)}-${number.substring(7, 11)}`
            }
        },
        inputNumber: function(number)
        {
            this.reset();
            if(this.number.length < 11)
            {   
                this.number += number;
            }
        },
        backspace: function()
        {
            this.reset();
            if(this.number.length > 3)
            {
                this.number = this.number.substring(0, this.number.length -1)
            }
        },
        enter: function()
        {
            this.reset();
            if(this.number.length === 11)
            {
                this.step = 1;   
            }
        },
        goBack: function()
        {
            this.$emit('back')
        },
        yes: function()
        {
            this.isLoading = true;
            this.reset();
             this.$store.dispatch(Constant.AUTH_INAPP, {type: this.authType, id: this.number, ref: null, isPolicyAgreed: true})
                .then((response) => {

                    this.$emit('complete')
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.$emit('complete')
                    this.isLoading = false;
                })
        },
        reset: function()
        {
          this.$emit('resetCount')
        }
    }
}
</script>

<style scoped>
    .input-phone {
        width: 100%;
        height: 100vh;
        overflow: hidden;    
        background: var(--theme-sub3);
    }
    .wrapper {
        padding: 6.2vh 5vw;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
    .header {
        height: 9vh;
        width: 100%;
        font-size: 2vh;
        color: #000;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5%;
        box-sizing: border-box;
        background: var(--theme-sub1);
    }
    .input-area {
        box-sizing: border-box;
        padding: 4.6vh 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-top: 2px solid var(--xi-gray-2, #C4CBD2);
        border-bottom: 2px solid var(--xi-gray-2, #C4CBD2);
    }
    .title {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vh;
        font-style: normal;
        font-weight: 700;
        line-height: 131%;
        letter-spacing: -2.64px;
    }
    .title-description {
        font-size: 1.8vh;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        letter-spacing: -2.88px;
        margin-top: 1.2vh;
    }
    .phone-input {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 1.5vh 12vw;
        margin-top: 3.8vh;
        box-sizing: border-box;
    }
    .input {
        width: 100%;
        height: 5vh;
        font-size: 5.2vw;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -2.4px;
        margin-top: 0.9vh;
    }
    .warning {
        color: var(--xi-blue, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 2.2vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.08px;
    }
    .number-pad {
        width: 100%;
        border: 2px solid var(--xi-gray-2, #C1C5C9);
        background: var(--theme-sub3);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .number-page-row {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .key {
        width: 100%;
        aspect-ratio: 1.6/1;
        background: var(--theme-sub3);;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .enter {
        width: 100%;
        aspect-ratio: 1.6/1;
        background: var(--xi-gray-1, #F0F1F4);
        display: flex;
        justify-content: center;
        align-items: center;

        color: var(--xi-gray-2, #C1C5C9);
        text-align: center;
        font-family: Pretendard;
        font-size: 3.8vw;
        font-style: normal;
        font-weight: 500;
        line-height: 0; /* 0% */
    }
    .enter-active{
        width: 100%;
        aspect-ratio: 1.6/1;
        background: var(--theme-main);
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--theme-sub3);
        text-align: center;
        font-family: Pretendard;
        font-size: 3.8vw;
        font-style: normal;
        font-weight: 500;
        line-height: 0; /* 0% */
    }
    .number {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 4.4vw;
        font-style: normal;
        font-weight: 500;
        line-height: 0; /* 0% */
        letter-spacing: -1.28px;
    }
    .pad-header {
        width: calc(100% + 4px);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border: 2px solid var(--xi-gray-2, #C1C5C9);
        border-bottom: 0;
        box-sizing: border-box;
        padding-top: 1.5vh;
    }
    .info-text {
        color: var(--xi-gray-3, #8F9499);
        text-align: center;
        font-family: Pretendard;
        font-size: 2.5vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.08px;
        margin-top: 4.6vh;

    }
    .input-check {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 3.8vh;
    }
    .phone-number-box {
        width: 66vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 7.6vh 0;
        background: var(--xi-gray-1, #F0F1F4);
        background: var(--theme-sub1);
    }
    .phone-number-info-text {
        color: var(--xi-blue, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 2.9vw;
        font-style: normal;
        font-weight: 500;
        line-height: 133.333%;
        letter-spacing: -1.44px;
    }
    .phone-number-text {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 5.5vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -2.4px;
        margin-top: 0.9vh;
    }
    .button-list {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2.7vw;
        margin-top: 1.5vh;
        padding: 0 4.2vw 6.2vh 4.2vw;
    }
    .button-yes {
        border-radius: 16px;
        background: var(--theme-main);
        width: 35vw;
        aspect-ratio: 2.55/1;
        color: var(--xi-gray-0, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button-no {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        width: 35vw;
        aspect-ratio: 2.55/1;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/InputPhone.vue